import axios from 'axios';
import { getUrlParameterValue } from './Parameters';
import Cookies from 'universal-cookie';

export async function allowGeolocation() {
  const isHonda = process.env.REACT_APP_THEME === 'honda';
  const geoServiceAcura = '/platform/api/v1/zipcode/ip';
  const geoServiceHonda = '/platform/api/v3/zipcode/ip';
  const geoService = isHonda ? geoServiceHonda : geoServiceAcura;
  const response = await axios.get(geoService).catch(function () {
    return null;
  });
  return response;
}

export async function getZipUrl(zipValue: string) {
  const zipUrl = '/platform/api/v1/address/citystate/' + zipValue;
  const validZipcode = new RegExp(/^\d{5}$/);
  const isZipcodeRegexApproved = zipValue.match(validZipcode);
  if (isZipcodeRegexApproved) {
    const response = await axios.get(zipUrl).catch(function () {
      return null;
    });
    return response;
  } else {
    return null;
  }
}

export function setZipcode(value: string) {
  const isHonda = process.env.REACT_APP_THEME === 'honda';
  if (isHonda) {
    const customEvent = new CustomEvent('zipcodeUpdate', {
      detail: {
        zipcode: value,
      },
    });
    window.dispatchEvent(customEvent);

    //The publish method below will affect the FE testing
    //It was added to fit with the current method used in Honda Autos
    //If you need to try the FE Charging Locator app, comment the line
    window.EventManager.publish('global-zip-update', value);
    const eventObject = new CustomEvent('global-zip-update', {
      detail: value,
    });
    document.dispatchEvent(eventObject);
  } else {
    localStorage.setItem('userZipCode', value);
    const customEvent = new CustomEvent('zipcodeUpdate', {
      detail: {
        zipcode: value,
      },
    });
    window.dispatchEvent(customEvent);
  }
}

export function getZipcode() {
  var zipcode = getUrlParameterValue('zipcode');
  const isHonda = process.env.REACT_APP_THEME === 'honda';
  const cookies = new Cookies();

  if (typeof zipcode === 'string') {
    zipcode = zipcode.replace(/\D/g, '');
  }

  if (!zipcode || zipcode.length !== 5) {
    if (isHonda) {
      zipcode = cookies.get('zipcode') || undefined;
    } else {
      zipcode = localStorage.getItem('userZipCode') || undefined;
    }
    if (zipcode && zipcode !== 'false') {
      return zipcode;
    }
    return '';
  }
  return zipcode;
}

export function openAutosZipgate() {
  /*WTSJOAHM-9397: We could try and theme the acura zipgate instead of calling the autos zipgate in a future ticket*/
  const waiting = 500;
  const zipTriggers: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.zip-gate-modal-trigger'
  );

  if (zipTriggers.length !== 0) {
    // Add class to all links that have zip-gate-modal-trigger as a css class.
    // Copied comment from the autos fe -> In order for site ttracking to work properly this css logic has to be introduced :(
    zipTriggers.forEach((el) => {
      el.classList.add('js-trigger');
    });

    zipTriggers[0].click();
    const zipModal: NodeListOf<HTMLElement> =
      document.querySelectorAll('.zip-gate-modal');
    if (zipModal.length !== 0) {
      const closer = zipModal[0].querySelector('.closer');
      if (closer) {
        closer.classList.remove('visible');
      }
    }

    setTimeout(() => {
      zipTriggers.forEach((el) => {
        el.classList.remove('js-trigger');
      });
    }, waiting);
  }
}
